import { Component, HostListener, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Socket } from 'socket.io-client';
import { SolicitudesPreciosAdministracionService } from 'src/app/services/empresa/solicitudes-precios-administracion.service';
import { SwitcherService } from 'src/app/shared/services/switcher.service';
@Component({
    selector: 'app-pages',
    templateUrl: './pages.component.html',
    styleUrls: ['./pages.component.scss'],
    standalone: false
})
export class PagesComponent implements OnInit, OnDestroy {

  public isMobile = window.matchMedia("(max-width: 991px)").matches;
  private priceRequestSocket?: Socket;

  constructor(
    public SwitcherService : SwitcherService,
    private solicitudesPreciosRealtime: SolicitudesPreciosAdministracionService,
    private zone: NgZone
  ) {

    
   }

   ngOnInit(): void {
    this.conectarSolicitudesPrecios();
  }

  ngOnDestroy(): void {
    this.priceRequestSocket?.disconnect();
  }
  

  mainSidebarOpen: any;
  hoverEffect($event:any) {
    this.mainSidebarOpen = $event.type == 'mouseover' ? 'sidenav-toggled-open' : '';
  }

  clickOnBody(){
    this.SwitcherService.emitChange(false);
    
  }

  scrolled: boolean = false;


  @HostListener('window:resize', [])
  onWindowScroll() {
    const isSmall = window.matchMedia("(max-width: 991px)").matches;
    this.scrolled = isSmall;
    this.isMobile = isSmall;
  }

  get showSidemenu(): boolean {
    return !this.isMobile;
  }

  private conectarSolicitudesPrecios(): void {
    this.priceRequestSocket = this.solicitudesPreciosRealtime.conectarSocket();

    this.priceRequestSocket.on('price_request.processed', (payload: any) => {
      this.zone.run(() => this.solicitudesPreciosRealtime.notificarSolicitudProcesada(payload));
    });
  }

}
